export enum Types {
	CONSULTAR_MUNICIPIOS_REQUEST = '@SGU/CONSULTAR_MUNICIPIOS_REQUEST',
	CONSULTAR_MUNICIPIOS_SUCCESS = '@SGU/CONSULTAR_MUNICIPIOS_SUCCESS',
	CONSULTAR_MUNICIPIOS_FAILURE = '@SGU/CONSULTAR_MUNICIPIOS_FAILURE',
	CONSULTAR_MUNICIPIOS_CLEAR = '@SGU/CONSULTAR_MUNICIPIOS_CLEAR',
}

export interface ConsultarMunicipios {
	status: number;
	data: null | Municipio[];
	totalRegistrosConsulta: number;
}

export interface Municipio {
	codigo: string | number;
	sigla: string;
	idMunicipio: string | number;
	nome: string;
	uf: string;
	descricao: string;
	id: number;
}

export interface ConsultarMunicipiosRequest {
	registroInicial?: number;
	limite?: number;
	current?: number;
	id?: number | string;
	descricao?: string;
	uf?: number | string;
}
export interface ConsultarMunicipiosNewRequest {
	page?: number;
	size?: number;
	id?: number | string;
	descricao?: string;
	uf?: number | string;
}
